import {PayloadAction} from "@reduxjs/toolkit";

export function onSidebarItemsChange (state: SidebarState, action: PayloadAction<SidebarItem[]>): void {
    state.items = action.payload;
}
export function onSidebarInOrdersChange (state: SidebarState, action: PayloadAction<boolean>): void {
    state.inOrders = action.payload;
}
export function onSidebarSidebarWithNavigateChange (state: SidebarState, action: PayloadAction<boolean>): void {
    state.withNavigate = action.payload;
}
export function onSidebarIsOpenChange (state: SidebarState, action: PayloadAction<boolean>): void {
    state.isOpen = action.payload;
}

export interface SidebarState {
    items: SidebarItem[],
    inOrders: boolean,
    withNavigate: boolean,
    isOpen: boolean
}

export interface SidebarItem {
    id: number,
    name: string
    countable?: boolean
}

